export const DEFAULT_EXCHANGE_ID = 'binance';

export const EXCHANGES_SELECT = [
    {
        name: 'Binance', 
        value: 'binance',
    },
];